<template>
    <span style="font-size: 14px; cursor: pointer; color: #347F7F;" @click.prevent="modalStatusStore.showLeadModal()">
        SEE PRICES
    </span>
</template>

<script setup>
import {useModalStatusStore} from "../../stores/ModalStatusStore";

const modalStatusStore = useModalStatusStore()
</script>
